import wrappedFetch from './base';

export const getTips = () => {
  return wrappedFetch('/tips.json')
    .then((response) => response.json());
};
